/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/modelli/polsino_3.glb");

  const { tessuto, club, matBottone } = props;

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        position={[-0.25, -0.33, -0.04]}
        rotation={[1.21, -0.04, -2.16]}
        scale={[0.5, 0.6, 0.5]}
        userData={{ name: "Node_37" }}
      >
        <mesh
          material={materials.Material55830}
          geometry={nodes.MatShape_12039_Node.geometry}
          userData={{ name: "MatShape_12039_Node" }}
        />
      </group>
      <group
        position={[-0.26, -0.33, -0.04]}
        rotation={[1.25, -0.07, 2.16]}
        scale={[0.5, 0.6, 0.5]}
        userData={{ name: "Node_39" }}
      >
        <mesh
          material={materials.Material55830}
          geometry={nodes.MatShape_12048_Node.geometry}
          userData={{ name: "MatShape_12048_Node" }}
          >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={'#D4AF37'}
          />
        </mesh>
      </group>
      <group
        position={[0.25, -0.32, -0.04]}
        rotation={[1.32, 0.11, 2.2]}
        scale={[0.5, 0.6, 0.5]}
        userData={{ name: "Node_41" }}
      >
        <mesh
          material={materials.Material55830}
          geometry={nodes.MatShape_12057_Node.geometry}
          userData={{ name: "MatShape_12057_Node" }}
        />
      </group>
      <group
        position={[0.26, -0.32, -0.04]}
        rotation={[1.23, 0.09, -2.18]}
        scale={[0.5, 0.6, 0.5]}
        userData={{ name: "Node_43" }}
      >
        <mesh
          material={materials.Material55830}
          geometry={nodes.MatShape_12066_Node.geometry}
          userData={{ name: "MatShape_12066_Node" }}
          >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={'#D4AF37'}
          />
        </mesh>
      </group>
      <mesh
        material={materials["FABRIC 1_FRONT_13567"]}
        geometry={nodes.Cuffs_9_Node.geometry}
        userData={{ name: "Cuffs_9_Node" }}
      >
        <meshStandardMaterial
          map={!club ? tessuto : null}
          roughness={1}
          toneMapped={false}
        />
      </mesh>
      <mesh
        material={materials["FABRIC 1_FRONT_13567"]}
        geometry={nodes.Cuffs_10_Node.geometry}
        userData={{ name: "Cuffs_10_Node" }}
      >
        <meshStandardMaterial
          map={!club ? tessuto : null}
          roughness={1}
          toneMapped={false}
        />
      </mesh>
    </group>
  );
}

useGLTF.preload("/modelli/polsino_3.glb");
